
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 -960 960 960"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M360-240L120-480l240-240 56 56-144 144h488v-160h80v240H272l144 144-56 56z"}})])
          )
        }
      }
    